export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-music-087d04f24baa93bbecab52cc507f1b11.svg";